module.exports = __webpack_public_path__ + "img/title-03-2(biz).151a387a.png";